<template>
  <Transition name="fade">
    <div class="card mb-4">
      <div class="card-header pb-0">
        <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Event Editor </span>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="p-0">
          <div class="px-4 m-0 row">
            <div class="card-header pb-0">
              <h6 class="d-inline">Event Details</h6>
              <span style="float: right">
                <argon-button @click="closeEditor()" id="changepwd" checked="true" color="secondary" variant="outline" class="mx-2" size="md">Revert</argon-button>
                <argon-button @click="createTemplatetemplate()" color="success" size="md">Save Changes</argon-button></span
              >
            </div>

            <div class="col-md-8">
              <label for="example-text-input" class="form-control-label">Event Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-4">
              <label for="event-selector" class="form-control-label">Service Level</label>
              <Multiselect
                v-model="value"
                mode="single"
                :close-on-select="false"
                :searchable="true"
                :options="[
                  { value: 'a', label: 'Single' },
                  { value: 'b', label: 'Selfie Attendance' },
                ]"
              />
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Event Address </label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-3">
              <label for="example-text-input" class="form-control-label">Event Date</label>
              <argon-input type="date" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>
            <div class="col-md-3">
              <label for="example-text-input" class="form-control-label">Event Time</label>
              <argon-input type="time" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-8">
              <label for="example-text-input" class="form-control-label">Event Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-4">
              <label for="event-selector" class="form-control-label">Service Level</label>
              <Multiselect
                v-model="value"
                mode="single"
                :close-on-select="false"
                :searchable="true"
                :options="[
                  { value: 'a', label: 'Single' },
                  { value: 'b', label: 'Selfie Attendance' },
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <Transition name="fade">
    <div class="card mb-4">
      <div class="card-header pb-0">
        <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Template Customizer</span>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="p-0">
          <div class="px-4 m-0 row">
            <div class="card-header pb-4">
              <h6 class="d-inline">Pick a template for the web invitation</h6>
              <div class="col-md-12">
                <div class="d-flex justify-content-start mt-2">
                  <argon-radio id="invTemplate1" name="templatechoice" class="mx-2"></argon-radio>
                  <label for="invTemplate1" style="height: 200px; cursor: pointer">
                    <img style="height: inherit" src="/Templates/Preview_1.svg" />
                  </label>
                  <argon-radio id="invTemplate2" name="templatechoice" class="mx-2"></argon-radio>
                  <label for="invTemplate2" style="height: 200px; cursor: pointer">
                    <img style="height: inherit" src="/Templates/Preview_2.svg" />
                  </label>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <label for="example-text-input" class="form-control-label">Cover Photo</label>
              <argon-input type="file" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="card-header pb-0">
              <h6 class="d-inline">Story #1</h6>
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Story Title #1</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Story Date #1</label>
              <argon-input type="date" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-4">
              <label for="example-text-input" class="form-control-label">Story Picture #1</label>
              <argon-input type="file" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">Story Description</label>
              <ckeditor :editor="editor" :config="editorConfig"></ckeditor>
            </div>

            <div class="card-header pb-0">
              <h6 class="d-inline">Story #2</h6>
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Story Title #2</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Story Date #2</label>
              <argon-input type="date" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-4">
              <label for="example-text-input" class="form-control-label">Story Picture #2</label>
              <argon-input type="file" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-12">
              <label for="example-text-input" class="form-control-label">Story Description</label>
              <ckeditor :editor="editor" :config="editorConfig"></ckeditor>
            </div>

            <div class="card-header pb-0">
              <h6 class="d-inline">Story #3</h6>
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Story Title #3</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Story Date #3</label>
              <argon-input type="date" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-4">
              <label for="example-text-input" class="form-control-label">Story Picture #3</label>
              <argon-input type="file" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-12 pb-2">
              <label for="example-text-input" class="form-control-label">Story Description</label>
              <ckeditor :editor="editor" :config="editorConfig"></ckeditor>
            </div>

            <div class="card-header pb-0">
              <h6 class="d-inline">Gallery | <span class="text-secondary text-xs opacity-6">Includes 1 from welcome section, and 3 from stories.</span></h6>
              <span style="float: right"> <argon-button @click="createTemplatetemplate()" color="success" size="md">Add Photo</argon-button></span>
            </div>

            <div class="col-md-8">
              <label for="example-text-input text-secondary" class="form-control-label mx-3">Gallery is empty</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <Transition name="fade">
    <div class="card mb-4">
      <div class="card-header pb-0">
        <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Bride and Groom Data Editor </span>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="p-0">
          <div class="px-4 m-0 row">
            <div class="card-header pb-0">
              <h6 class="d-inline">Groom Data (Man)</h6>
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Groom Full Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-4">
              <label for="example-text-input" class="form-control-label">Groom Nickname</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Groom Photo</label>
              <argon-input type="file" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Groom Fathers Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Groom Mother's Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="card-header pb-0">
              <h6 class="d-inline">Bride Data (Woman)</h6>
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Bride Full Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-4">
              <label for="example-text-input" class="form-control-label">Bride Nickname</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Bride Photo</label>
              <argon-input type="file" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Bride Fathers Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Bride Mother's Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <Transition name="fade">
    <div class="card mb-4">
      <div class="card-header pb-3">
        <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Bank Accounts | <span class="text-xs text-secondary opacity-6">Used to receive gifts from guests</span></span>
        <span style="float: right">
          <argon-button @click="createTemplatetemplate()" color="success" size="md">Add New Bank</argon-button>
        </span>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="p-0">
          <div class="px-4 m-0 row">
            <div class="col-md-2">
              <label for="event-selector" class="form-control-label">Bank</label>
              <Multiselect
                v-model="value"
                mode="single"
                :close-on-select="false"
                :searchable="true"
                :options="[
                  { value: 'a', label: 'BCA' },
                  { value: 'b', label: 'BNI' },
                  { value: 'c', label: 'MANDIRI' },
                  { value: 'd', label: 'BRI' },
                  { value: 'e', label: 'BTN' },
                  { value: 'f', label: 'Single' },
                  { value: 'g', label: 'JAGO' },
                  { value: 'h', label: 'DANA (MUST INCLUDE QR)' },
                  { value: 'h', label: 'OVO (MUST INCLUDE QR)' },
                  { value: 'h', label: 'SHOPEE (MUST INCLUDE QR)' },
                ]"
              />
            </div>

            <div class="col-md-4">
              <label for="example-text-input" class="form-control-label">Account Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter the account name" />
            </div>

            <div class="col-md-3">
              <label for="example-text-input" class="form-control-label">Account Number</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter the account number" />
            </div>

            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">QR (Optional)</label>
              <argon-input type="file" id="newfullname" value="" placeholder="Enter new guest name" />
            </div>
            <div class="col-md-1">
              <label for="example-text-input" class="form-control-label"> Delete </label>
              <argon-button @click="createTemplatetemplate()" color="danger" size="md"><i class="fa fa-trash-o" aria-hidden="true"></i></argon-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
  import ArgonInput from "@/components/ArgonInput.vue";
  import $ from "jquery";
  import ArgonButton from "@/components/ArgonButton.vue";
  import ArgonRadio from "@/components/ArgonRadio.vue";
  import Multiselect from "@vueform/multiselect";
  import ArgonSwitch from "@/components/ArgonSwitch.vue";
  import "@vueform/multiselect/themes/default.css";
  import axios from "axios";
  import CKEditor from "@ckeditor/ckeditor5-vue";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

  export default {
    name: "template-editor",
    props: {
      cardBg: String,
      selectedOption: {},
    },
    components: {
      ArgonInput,
      ArgonButton,
      ArgonSwitch,
      Multiselect,
      ArgonRadio,
      ckeditor: CKEditor.component,
    },
    data() {
      return {
        templatedata: {},
        selects: {},
        editor: ClassicEditor,
        editorConfig: {
          toolbar: ["Bold", "Underline", "Italic"],
        },
        item: {
          id: 1,
          // both the commented out value and the
          // active value don't work
          // relatedItem: {
          //   value: 100,
          //   label: "test",
          // },
          relatedItem: 100,
        },
      };
    },
    computed: {
      isSuper() {
        return localStorage.getItem(sha256("isSuper").toString());
      },
      isEditor() {
        return this.$store.state.templateEditor;
      },
      gettemplateData() {
        return this.templatedata;
      },
      options() {
        return this.options;
      },
    },
    methods: {
      getRoute() {
        const routeArr = this.$route.path.split("/");
        return routeArr[1];
      },
      toggleResetPass() {
        console.log($("#changepwd").is("checked"));
        return (this.$store.state.templateEditor.resetPass = !this.$store.state.templateEditor.resetPass);
      },
      closeEditor() {
        this.$store.state.templateEditor.isOpen = false;
      },
      updatePassword() {
        if ($("#newpass").val() == $("#newpassconfirm").val()) {
          let JWTToken = localStorage.getItem("token");
          let cred = {
            password: $("#newpass").val(),
          };

          axios
            .patch("https://api.macra.co.id/mavent/admin/reset-password", cred, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              alert(res.message);
            })
            .catch((error) => {
              alert(error);
            });
        } else {
          $("#newpass").prop("required", true);
          $("#newpassconfirm").prop("required", true);
          setTimeout(() => {
            $("#newpass").prop("required", false);
            $("#newpassconfirm").prop("required", false);
          }, 3000);
          return alert("Both passwords have to be the same");
        }

        event.preventDefault();
      },
      createTemplatetemplate() {
        if ($("#newaccpwd").val() == $("#newaccpwdconfirm").val()) {
          let JWTToken = localStorage.getItem("token");
          let cred = {
            full_name: $("#newfullname").val(),
            email: $("#newemail").val(),
            username: $("#newusername").val(),
            password: $("#newaccpwd").val(),
          };

          axios
            .post("https://api.macra.co.id/mavent/admin/add", cred, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              alert(res.status);
            })
            .catch((error) => {
              alert(error);
            });
        } else {
          return alert("Both passwords have to be the same");
        }

        event.preventDefault();
      },

      encrypt(ele) {
        return sha256(ele);
      },
      getAdminData(row) {
        return (this.templatedata = this.$store.state.adminlist.rows[row]);
      },
      async fetchOptions(search) {
        console.log(search);
        // hits an API
        // /api/items/search?search=${search}
        return new Promise((resolve) => {
          setTimeout(() => {
            if (search) {
              resolve([
                {
                  value: 100,
                  label: "test",
                },
                {
                  value: 101,
                  label: "test2",
                },
              ]);
            } else {
              resolve([]);
            }
          }, 200);
        });
      },
    },
    mounted() {
      if (this.$store.state.templateEditor.requestedrow != null) {
        this.getAdminData(this.$store.state.templateEditor.requestedrow);
      }
    },
  };
</script>
